module.exports = __webpack_public_path__ + "img/T6-D-xh_11.a782fb02.png";